<template>
  <div class="second">
    <div class="title"></div>
      <div class="tian-top"></div>
      <div class="lou"></div>
    <div class="qiao"></div>
    <div class="shui_bg"></div>

    <div class="second_clouds"></div>
    <div class="second_clouds_two"></div>

<!--    车辆-->
    <div class="car"></div>
    <div class="wave wave01"></div>
    <div class="travelling"></div>
    <div class="wa"></div>
    <div class="wave wave02"></div>
    <div class="wave wave03"></div>
    <div class="wave wave04"></div>
    <div class="wave wave05"></div>
    <div class="wave wave06"></div>
    <div class="wave wave07"></div>

<!--    右下角船-->
    <div class="wave wave08"></div>
    <div class="wave wave09"></div>
    <div class="wave wave10"></div>
  </div>
</template>

<script>
export default {
  name: "second.vue"
}
</script>

<style scoped>
.second{
  position: relative;
}
.second .title{
  width: 515px;
  height: 173px;
  position: absolute;
  background: url("../../public/guangming_milk/title/2_title.png") no-repeat;
  background-size: 100% 100%;
  left: 22px;
  top: 22px;
  z-index: 5;
}
.tian-top{
  width: 750px;
  height: 1567px;
  background: url("../../public/guangming_milk/two/tian1.png") no-repeat;
  background-size: 100% 519px;
}
.second .lou{
  width: 100%;
  height: 1567px;
  background: url("../../public/guangming_milk/two/second_lou3.png") no-repeat;
  background-size: 100% 1567px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
}
.shui_bg{
  width: 100%;
  height: 888px;
  background: url("../../public/guangming_milk/two/shui.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 519px;
  left: 0px;
  z-index: 1;
}
.second_clouds{
  z-index: 1;
  position: absolute;
  width: 121px;
  height: 68px;
  background: url("../../public/guangming_milk/one/yun4.png") no-repeat;
  background-size: 100% 100%;
  top: 187px;
  right: -40px;
  -webkit-animation: second_clouds 105s linear infinite;
  -moz-animation: second_clouds 105s linear infinite;
  -o-animation: second_clouds 105s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
@-webkit-keyframes second_clouds {
  0%{
    left: -200px;
  }
  100%{
    left: 120%;
  }
}
.second_clouds_two{
  z-index: 1;
  position: absolute;
  width: 148px;
  height: 75px;
  background: url("../../public/guangming_milk/one/yun3.png") no-repeat;
  background-size: 100% 100%;
  top: 110px;
  right: -40px;
  -webkit-animation: second_clouds_two 130s linear infinite;
  -moz-animation: second_clouds_two 130s linear infinite;
  -o-animation: second_clouds_two 130s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
@-webkit-keyframes second_clouds_two {
  0%{
    left: 100%;
  }
  100%{
    left: -180px;
  }
}
.car{
  width: 239px;
  height: 198px;
  /*background: url('../../public/guangming_milk/png/2_car.png') no-repeat;*/
  /*background-size: 100% 100%;*/
  position: absolute;
  z-index: 5;
  top: 360.5px;
  right: -239px;
  /*animation: cars 5s cubic-bezier(0,0,.5,0.87) infinite;*/
  animation: cars 5s cubic-bezier(0,0,.69,0.9) infinite;
}
.car:after{
  content: '';
  display: block;
  width: 239px;
  height: 198px;
  position: absolute;
  z-index: 5;
  background: url('../../public/guangming_milk/png/3_car.gif') no-repeat;
  background-size: 100% 100%;
  /*animation: cars2 5s cubic-bezier(.66,.01,1,1) infinite;*/
  animation: cars2 5s cubic-bezier(.66,.45,1,1) infinite;
}
@keyframes cars{
  /*0%{*/
  /*  opacity: 1;*/
  /*}*/
  /*65%{*/
  /*  opacity: 1;*/
  /*}*/
  0%{
    transform: scale(0.5);
  }
  90%{
    opacity: 1;
  }
  100%{
    /*transform: translate(-360px,360px);*/

    transform: translateX(-700px);
    opacity: 0;
  }
}
@keyframes cars2{
  to{transform: translateY(400px)}
}

.wave{
  width: 316px;
  height: 36px;
  background: url("../../public/guangming_milk/png/wave.png")no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 2;
}
.wave01{
  top: 607px;
  -webkit-animation: wave 2s linear infinite;
  -moz-animation: wave 2s linear infinite;
  -o-animation: wave 2s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
.wave02{
  top: 705px;
  left: -50px;
  -webkit-animation: wave2 1s linear infinite;
  -moz-animation: wave2 1s linear infinite;
  -o-animation: wave2 1s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
.wave03{
  top: 757px;
  left: -50px;
  -webkit-animation: wave2 2s linear infinite;
  -moz-animation: wave2 2s linear infinite;
  -o-animation: wave2 2s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
.wave04{
  top: 832px;
  left: -50px;
  -webkit-animation: wave3 4s linear infinite;
  -moz-animation: wave3 4s linear infinite;
  -o-animation: wave3 4s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
.wave05{
  top: 892px;
  left: -50px;
  -webkit-animation: wave2 1s linear infinite;
  -moz-animation: wave2 1s linear infinite;
  -o-animation: wave2 1s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
.wave06{
  top: 975px;
  left: -50px;
  -webkit-animation: wave2 2s linear infinite;
  -moz-animation: wave2 2s linear infinite;
  -o-animation: wave2 2s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
.wave07{
  top: 1050px;
  left: -50px;
  -webkit-animation: wave2 1s linear infinite;
  -moz-animation: wave2 1s linear infinite;
  -o-animation: wave2 1s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
.wave08{
  top: 1207px;
  right: 30px;
  -webkit-animation: wave2 1s linear infinite;
  -moz-animation: wave2 1s linear infinite;
  -o-animation: wave2 1s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
.wave09{
  top: 1257px;
  right:-25px;
  -webkit-animation: wave2 1s linear infinite;
  -moz-animation: wave2 1s linear infinite;
  -o-animation: wave2 1s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
.wave10{
  top: 1327px;
  right:-25px;
  -webkit-animation: wave 1s linear infinite;
  -moz-animation: wave 1s linear infinite;
  -o-animation: wave 1s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
@keyframes wave{
  0%{
    transform: translateY(0px);
  }
  25%{
    transform: translateY(4px);
  }
  40%{
    transform: translateY(-4px);
  }
  60%{
    transform: translateY(0px);
  }
  80%{
    transform: translateY(-4px);
  }
  100%{
    transform: translateY(0px);
  }
}
@keyframes wave2 {
  50%{transform:translateY(4px)}
}
@keyframes wave3 {
  50%{transform:translateY(8px)}
}


.qiao {
  width: 191px;
  height: 217px;
  background: url("../../public/guangming_milk/png/qiao.png");
  background-size: 100% 100%;
  position: absolute;
  z-index: 10;
  top: 660px;
  left: 313px;
}

.travelling {
  width: 302px;
  height: 369px;
  background: url("../../public/guangming_milk/two/2-xiaozun.gif");
  background-size: 100% 100%;
  position: absolute;
  z-index: 11;
  bottom: 295px;
  left: 10px;
}
.wa{
  width: 280px;
  height: 161px;
  background: url("../../public/guangming_milk/png/wa.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 11;
  bottom: 630px;
  left: 25px;
}
</style>
